import {
   CardContent
  ,Fade
} from 'external/material'
import Card from './Card'
import Group from './Group'
import Teacher from './Teacher'
import Assignments from './Assignments'
import useStudentContext from 'hooks/student'
import useSession from 'hooks/session'

export default function CourseItem(props) {
  const {groupId} = useSession()
  const {groups} = useStudentContext()
  const group = groups.find(g => g.id == groupId)
  return (
    <Fade in={!!group}>
      <Card>
        <CardContent>
          {group && <Teacher {...group} />}
          {group && <Group {...group} />}
          {group && <Assignments {...group} />}
        </CardContent>
      </Card>
    </Fade>
  )
}
